<app-loading-state *ngIf="!ready" message="Cargando préstamo…"></app-loading-state>
<convfact-prestamos-form *ngIf="ready" [prestamos]="prestamos" (onSave)="saveData($event)">
</convfact-prestamos-form>
